import Swiper from 'swiper';
import {
  Navigation,
  Scrollbar,
  Autoplay,
  EffectFade,
  Pagination,
} from 'swiper/modules';
import 'swiper/css/pagination';

(function (once) {
  Drupal.behaviors.swiperBehavior = {
    attach: function (context, settings) {
      once('swiperBehavior', 'div.swiper-container', context).forEach(
        function (element) {
          const swiperElement = element.querySelector('.swiper');
          const config = element.dataset?.swiperConfig
            ? JSON.parse(element.dataset?.swiperConfig)
            : [];
          const swiper = new Swiper(swiperElement, {
            speed: 300,
            modules: [Navigation, Scrollbar, Autoplay, EffectFade, Pagination],
            navigation: {
              nextEl: element.querySelector('.swiper-button-next'),
              prevEl: element.querySelector('.swiper-button-prev'),
            },
            ...config,
          });

          if (config?.autoPlay) {
            swiper.autoplay.start();
          }
        }
      );
    },
  };
})(once);
